import { TableHeadCell } from "@shared/primitive-components"

export const vehicleHeaderProps = {
  header: `Vehicle`,
  tooltipContent: `The registration number and details about each individual vehicle in your fleet`,
}

export const VehicleHeader = () => <TableHeadCell {...vehicleHeaderProps} />
